import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import PageMeta from 'components/PageMeta';

export default function BlockedIndex(props) {
  return (
    <div
      className="fullsize d-flex flex-column background-cover background-fixed background-image-center"
      style={{
        backgroundImage: `url(${require('static/backgrounds/ff-saleslanding-image-header-backdrop-landon-parenteau-EEuDMqRYbx0-unsplash.jpg')})`
      }}
    >
      <PageMeta
        title="Sorry!"
        description="Unfortunately, we aren't able to offer this screening in Germany, Switzerland, Austria, Luxembourg, Tyrol, or Japan."
      />
      <div className="page d-flex flex-column">
        <Container className="my-auto">
          <div className="background-white box-shadow-black-50 rounded p-4 p-lg-5 my-5">
            <Row>
              <Col>
                <p>
                  Unfortunately, we aren't able to offer this screening in Germany, Switzerland, Austria, Luxembourg,
                  Tyrol, or Japan. Because your IP address is from one of those countries, we can’t let you register to
                  watch this Special Event Edition of <i>Fantastic Fungi.</i>
                </p>
                <p>
                  But you can still rent or buy the <i>Fantastic Fungi</i> film by{' '}
                  <a href="https://fantasticfungi.com/watch/" target="_blank">
                    clicking here
                  </a>
                  .
                </p>
                <p>
                  You can also learn more about the <i>Fantastic Fungi</i> mission and access extra resources at{' '}
                  <a href="https://fantasticfungi.com/" target="_blank">
                    https://fantasticfungi.com/
                  </a>
                  .
                </p>
                <p>We thank you for your interest, and we apologize for the inconvenience.</p>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
}
